import angular from 'angular';
import ingredientListComponent from './ingredient-list.component';

export default angular.module('components.app.product.ingredientList', [])
  .component('productIngredientList', ingredientListComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/product/ingredient-list/ingredient-list.module.js